import React from 'react';
import './style.css';

const RiskOverviewStandardSectionHeader = ({ title }) => {
    return (
        <h2 className="risk-overview-section-header text-align-center" dangerouslySetInnerHTML={{ __html: title }} />
    );
};

export default RiskOverviewStandardSectionHeader;
